import React from 'react';
import { LockIcon, ShieldCheckIcon, ZapIcon } from 'lucide-react';
export function TopBar() {
  return <header className="sticky top-0 z-50 border-b border-sky-100 bg-white/95 shadow-sm backdrop-blur" data-id="element-334" data-mp="232nfsn0fptzi">
      <div className="bg-primary px-3 py-1.5 text-center font-display text-[10px] font-bold tracking-wide text-white sm:text-xs md:text-sm" data-id="element-335" data-mp="1y4vej2dwgvin">
        🇦🇷 Sistema N°1 para Emprendedores en Argentina
      </div>
      <div className="mx-auto hidden max-w-5xl items-center justify-center gap-7 py-2 text-xs font-medium text-slate-500 md:flex" data-id="element-336" data-mp="2qr6dy9prsqdv">
        <span className="flex items-center gap-1.5" data-id="element-337" data-mp="2lvhleqc649r2">
          <ZapIcon className="h-3.5 w-3.5 text-teal" data-id="element-338" data-mp="2h1woz2q83ntz" /> Acceso en 5 minutos
        </span>
        <span className="text-slate-300" data-id="element-339" data-mp="2c43e3wdz65nd">·</span>
        <span className="flex items-center gap-1.5" data-id="element-340" data-mp="2c3bmsxreuu2w">
          <LockIcon className="h-3.5 w-3.5 text-teal" data-id="element-341" data-mp="39j8wxrpvwira" /> Pago seguro
        </span>
        <span className="text-slate-300" data-id="element-342" data-mp="34sisqht72ly6">·</span>
        <span className="flex items-center gap-1.5" data-id="element-343" data-mp="34qoa5a5eb5x9">
          <ShieldCheckIcon className="h-3.5 w-3.5 text-teal" data-id="element-344" data-mp="24ppchpcpeva" /> Garantía de 7 días
        </span>
      </div>
    </header>;
}